import ListingLibStringCell from 'framework-listing-lib/table/ListingLibStringCell';
import ListingLibTruncateDiv from 'framework-listing-lib/table/ListingLibTruncateDiv';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TableCellWithoutPropertyDefinition({
  value
}) {
  return /*#__PURE__*/_jsx(ListingLibTruncateDiv, {
    children: /*#__PURE__*/_jsx(ListingLibStringCell, {
      value: value
    })
  });
}